<ul class="field-wrapper show-empty-label" [class]="wrapperClassList()">
  @if (showLabel()) {
    <li class="field-label" [innerHTML]="label()" [class.multiline-label]="multilineLabel()"></li>
  }

  @if (hasLabelTemplate()) {
    <li class="field-label">
      <ng-content select=[labelTemplate]></ng-content>
    </li>
  }

  <li class="field-element" [class]="fieldClassList()">
    <div class="component-wrapper" (focusin)="onFocus()" (focusout)="onBlur()">
      <ng-content></ng-content>
    </div>
  </li>

  @if (showNote() || (isInvalid() && (errorMessage$ | async))) {
    <li
      class="field-note"
      test-id="field-note"
      [class.has-character-counter]="hasCharacterCounter()"
      [class]="fieldNoteClass()">
      @if (isInvalid()) {
        <span [innerHTML]="errorMessage$ | async"></span>
      } @else {
        <span [innerHTML]="note()"></span>
      }
    </li>
  }

   <li class="extras-container">
    <span [class.characters-counter]="!isInvalid()" #charactersCounter></span>

    @if (hasExtraAction()) {
      <button
        class="extra-action-button"
        type="button"
        msButton="link"
        [disabled]="extraActionDisabled()"
        (click)="onExtraActionClick()"
      >
        {{ extraActionLabel() }}
      </button>
    }
   </li>
</ul>
